<template>
  <v-card outlined>
    <v-card-text>
      <v-layout row wrap align-center justify-space-between fill-height>
        <v-flex xs12 sm3>
          <v-text-field
            @focus="$event.target.select()"
            label="Category"
            v-model="category"
            outlined
            dense
            hide-details
            autocomplete
            ref="categoryRef"
          />
        </v-flex>

        <v-flex xs12 sm5>
          <v-text-field
            @focus="$event.target.select()"
            label="Item Name"
            ref="itemName"
            v-model="name"
            outlined
            dense
            hide-details
            autocomplete
          />
        </v-flex>

        <v-flex xs12 sm2>
          <v-text-field
            class="right-input"
            ref="unitPrice"
            @focus="$event.target.select()"
            label="Amount"
            v-model.number="amount"
            outlined
            type="number"
            dense
            hide-details
          />
        </v-flex>

        <!-- Ramadan fields -->
        <v-flex xs12 sm2 v-if="detailStyle === 'fast'">
          <v-text-field
            outlined
            dense
            hide-details
            type="date"
            label="Date"
            v-model="date"
          />
        </v-flex>

        <v-flex xs12 sm2 v-if="detailStyle === 'fast'">
          <v-text-field outlined dense hide-details label="Day" v-model="day" />
        </v-flex>

        <v-flex xs12 sm2 v-if="detailStyle === 'fast'">
          <v-text-field
            outlined
            dense
            hide-details
            type="number"
            label="Visitors"
            v-model.number="visitors"
          />
        </v-flex>

        <!-- Student/Units fields -->
        <v-flex
          xs12
          sm2
          v-if="detailStyle === 'student' || detailStyle === 'units'"
        >
          <v-text-field
            outlined
            dense
            hide-details
            type="number"
            label="Total Qty"
            v-model.number="totalQuantity"
          />
        </v-flex>

        <v-flex d-flex xs12 sm1>
          <v-btn color="info" ref="addbutton" large @click="submit">
            add
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    detailStyle: { type: String, default: "normal" }, // normal | ramadan | student | units
  },

  data() {
    return {
      category: null,
      name: null,
      amount: 0,

      // ramadan
      date: null,
      day: null,
      visitors: null,

      // student/units
      totalQuantity: null,
    };
  },

  methods: {
    emptyEntryBar() {
      this.name = null;
      this.amount = 0;
      this.date = null;
      this.day = null;
      this.visitors = null;
      this.totalQuantity = null;

      setTimeout(() => {
        this.$refs.itemName && this.$refs.itemName.focus();
      }, 200);
    },

    submit() {
      const row = {
        category: this.category,
        name: this.name,
        amount: this.amount,
      };

      // Attach fields based on campaign style
      if (this.detailStyle === "fast") {
        row.pricingMode = "fixed";
        row.billingMode = "one_time";
        row.allowQuantity = false;

        row.date = this.date;
        row.day = this.day;
        row.visitors = this.visitors;
      }

      if (this.detailStyle === "student") {
        row.pricingMode = "unit";
        row.capMode = "quantity";
        row.allowQuantity = true;
        row.totalQuantity = this.totalQuantity;
        row.soldQuantity = 0;
        // billing choice should be donor-side later, so keep it simple here
      }

      if (this.detailStyle === "units") {
        row.pricingMode = "unit";
        row.capMode = "quantity";
        row.allowQuantity = true;
        row.totalQuantity = this.totalQuantity;
        row.soldQuantity = 0;
      }

      // normal: nothing extra

      this.$emit("submit", row);
      this.emptyEntryBar();
    },
  },
};
</script>

<style scoped>
.right-input input {
  text-align: right;
}
</style>